
import * as constants from "../Constatnts";
import axios from "axios";

// export function addInventory(inventory) {
//   return (dispatch, getState) => {
//     inventory.ActionOn = firebase.firestore.FieldValue.serverTimestamp();
//     inventory.ActionBy = getState().user.user.Name;
//     inventory.ActionByUID = getState().user.user.UID;
//     inventory.ActionByEmailID = getState().user.user.EmailID;
//     inventory.Action = constants.AUDIT_TRAIL_NEW;
//     return database
//       .collection("Inventory")
//       .add({
//         ...inventory,
//       })
//       .then(function(docRef) {
//         return docRef.id;
//       })
//       .catch(function(error) {
//         console.error("Error saving Inventory : ", error);
//       });
//   };
// }

export function updateInStockQty(key, qty) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

        const response = await axios.put(
        `${constants.API_URL}/inventory/instock/${key}`,
        { qty },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if(response.data.code=="0"){
        return true
      }
      else{
        return false
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}
export function addInventory(inventory) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.post(
        `${constants.API_URL}/transaction/inventory`, inventory,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      return  response.data.inventory.id;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getInventoryList(
  from = 0,
  size = 25,
  updatedOn = null,
  storeId = null,
  fromDate = null,
  toDate = null,
  transactionTypeId = null,
  transactionNo = null,
  vendorFirstName = null,
  vendorEmailId = null,
  vendorPhoneNo = null,
  searchParam = null,
  status = null,
  vendorCode = null
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      let apiUrl = "/transaction/inventory";
      let queryParams = [];

      const formatDateParam = (date) => {
        return date ? new Date(date).toISOString().split("T")[0] : null;
      };

      if (status) {
        queryParams.push(`status=${encodeURIComponent(status)}`);
      }

      // ✅ allow 0
      if (from !== null && from !== undefined) {
        queryParams.push(`from=${from}`);
      }

      if (size !== null && size !== undefined) {
        queryParams.push(`size=${size}`);
      }

      if (updatedOn) {
        queryParams.push(`updatedOn=${formatDateParam(updatedOn)}`);
      }

      if (storeId) {
        if (Array.isArray(storeId)) {
          const storeIdsString = storeId.filter(id => id).join(",");
          if (storeIdsString) {
            queryParams.push(`storeId=${encodeURIComponent(storeIdsString)}`);
          }
        } 
        // ✅ prevent crash if not string
        else if (typeof storeId === "string" && storeId.trim() !== "") {
          queryParams.push(`storeId=${encodeURIComponent(storeId)}`);
        }
      }

      if (fromDate) {
        queryParams.push(`fromDate=${formatDateParam(fromDate)}`);
      }

      if (toDate) {
        queryParams.push(`toDate=${formatDateParam(toDate)}`);
      }

      if (vendorCode) {
        queryParams.push(`vendorCode=${encodeURIComponent(vendorCode)}`);
      }

      if (transactionTypeId) {
        queryParams.push(`transactionTypeId=${encodeURIComponent(transactionTypeId)}`);
      }

      if (transactionNo) {
        queryParams.push(`transactionNo=${encodeURIComponent(transactionNo)}`);
      }

      if (vendorFirstName) {
        queryParams.push(`vendorFirstName=${encodeURIComponent(vendorFirstName)}`);
      }

      if (vendorEmailId) {
        queryParams.push(`vendorEmailId=${encodeURIComponent(vendorEmailId)}`);
      }

      if (vendorPhoneNo) {
        queryParams.push(`vendorPhoneNo=${encodeURIComponent(vendorPhoneNo)}`);
      }

      if (searchParam) {
        queryParams.push(`searchParam=${encodeURIComponent(searchParam)}`);
      }

      if (queryParams.length > 0) {
        apiUrl += "?" + queryParams.join("&");
      }

      const response = await axios.get(constants.API_URL + apiUrl, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return response.data;
    } catch (err) {
      console.error("Error fetching sales history:", err);
      throw err;
    }
  };
}


export function updateInventory(inventory, id) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.put(
        `${constants.API_URL}/transaction/inventory/${id}/edit`,
        inventory,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function cancelInventory(cancellationReason, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.post(
        `${constants.API_URL}/transaction/inventory/${key}/cancel`,
        {
          CancellationReason: cancellationReason,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}
// export function cancelInventory(cancellationReason, key) {
//   return (dispatch, getState) => {
//     let actionOn = firebase.firestore.FieldValue.serverTimestamp();
//     let actionBy = getState().user.user.Name;
//     let actionByUID = getState().user.user.UID;
//     let actionByEmailID = getState().user.user.EmailID;
//     let action = "CANCEL";
//     return database
//       .collection("Inventory")
//       .doc(key)
//       .update({
//         Status: "Cancelled",
//         BackEndUpdate: false,
//         CancellationReason: cancellationReason,
//         ActionOn: actionOn,
//         ActionBy: actionBy,
//         ActionByUID: actionByUID,
//         ActionByEmailID: actionByEmailID,
//         Action: action,
//       });
//   };
// }

// export function getInventoryRunningNo(storeID, transactionTypeID) {
//   return (dispatch) => {
//     return database
//       .collection("TransactionRunningNo")
//       .doc("inventory" + storeID + transactionTypeID)
//       .get()
//       .then((doc) => {
//         let runningNo = 1;
//         if (doc.exists) {
//           runningNo = Number(doc.data().RunningNo) + 1;
//         }
//         return runningNo;
//         // return database.collection("TransactionRunningNo").doc("inventory" + storeID + transactionTypeID).set({
//         //     StoreID:storeID, TransactionTypeID:transactionTypeID, RunningNo: runningNo
//         // }).then(()=>{
//         //     return runningNo
//         // })
//       });
//   };
// }

// export function updateInventoryRunningNo(
//   storeID,
//   transactionTypeID,
//   runningNo
// ) {
//   return (dispatch) => {
//     return database
//       .collection("TransactionRunningNo")
//       .doc("inventory" + storeID + transactionTypeID)
//       .set({
//         StoreID: storeID,
//         TransactionTypeID: transactionTypeID,
//         RunningNo: runningNo,
//       })
//       .then(() => {
//         return runningNo;
//       });
//   };
// }

export function getInventoryDetails(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/transaction/inventory/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data.inventory;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function getProductInStockQty(storeID, locationID, productId) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/inventory/instock`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            storeID,
            locationID,
            productId,
          },
        }
      );

      return response.data.inStockQty;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getInStockQtyForProducts(storeID, locationID = "", productIDs) {
  return async (dispatch, getState) => {
    try {
     let searchStores = JSON.stringify([{
      value: storeID
    }]);

      const params = {
        searchStores,
        productIDs,
        locationID,
      };

      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/inventory/instockbyproductids`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

// export function getInStockQtyForProducts(storeID, locationID = "", productIDs) {
//   let searchParameters = {
//     from: 0,
//     size: 10000,
//     track_total_hits: true,
//     query: {
//       bool: {
//         must: [
//           {
//             match: {
//               StoreID: storeID,
//             },
//           },
//           {
//             terms: {
//               "ProductID.keyword": productIDs,
//             },
//           },
//         ],
//       },
//     },
//   };
//   if (locationID !== "") {
//     searchParameters.query.bool.must.push({
//       match: {
//         LocationID: locationID,
//       },
//     });
//   }
//   return (dispatch) => {
//     let addMessage = firebase.functions().httpsCallable("getInventoryInStock");
//     return addMessage({ text: searchParameters }).then(function(result) {
//       // console.log("searchParameters",JSON.stringify(searchParameters))
//       // console.log("result",result)
//       const inventory = [];
//       let sanitizedMessage = result.data.text;
//       sanitizedMessage.hits.hits.map((data, index) => {
//         inventory.push({
//           key: data._source.ProductID,
//           InStockQty: data._source.InStockQty,
//           PincodeProductID: data._source.PincodeProductID,
//         });
//       });
//       return {
//         totalItemsCount: sanitizedMessage.hits.total.value,
//         searchResult: inventory,
//       };
//     });
//   };
// }


export function getInwardUniqueList(from,
  size,
  storeID,
  productID,
  searchText) {
  return async (dispatch, getState) => {
    try {
        const params = new URLSearchParams({
      storeID,
      from,
      size
    });

    if (productID) {
      params.append('productID', productID);
    }

    if (searchText.trim()) {
      params.append('searchText', searchText.trim());
    }
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/transaction/inventory/inwarduniqueno?${params.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getUniqueListForSalesReturn(from,
  size,
  storeID,
  productID,
  searchText) {
  return async (dispatch, getState) => {
    try {
        const params = new URLSearchParams({
      storeID,
      from,
      size
    });

    if (productID) {
      params.append('productID', productID);
    }

    if (searchText.trim()) {
      params.append('searchText', searchText.trim());
    }
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/transaction/inventory/outwarduniqueno?${params.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


// export function getInwardUniqueList(from, size, storeID, productID, uniqueNo) {
//   let searchParameters = {
//     "from": from,
//     "size": size,
//     "query": {
//       "bool": {
//         "must": [
//           {
//             "match": {
//               "StoreID": storeID
//             }
//           },
//           {
//             "match": {
//               "Movement": "inward"
//             }
//           },
//           {
//             "match": {
//               "IsDeleted": false
//             }
//           }
//         ],
//         "filter": {
//           "bool": {
//             "should": [],
//             "minimum_should_match": 1
//           }
//         }
//       }
//     },
//     "sort": [
//       {
//         "ActionOn": {
//           "order": "desc"
//         }
//       }
//     ]
//   }

//   if (uniqueNo.trim() !== "") {
//     searchParameters.query.bool.filter.bool.should.push({ "match_phrase": { "UniqueNo1":  uniqueNo.trim().toLowerCase()}})
//     searchParameters.query.bool.filter.bool.should.push({ "match_phrase": { "UniqueNo2":  uniqueNo.trim().toLowerCase()}})
//     searchParameters.query.bool.filter.bool.should.push({ "match_phrase": { "UniqueNo3":  uniqueNo.trim().toLowerCase()}})
//     searchParameters.query.bool.filter.bool.should.push({ "match_phrase": { "UniqueNo4":  uniqueNo.trim().toLowerCase()}})
//   }
//   if(productID!=="")
//   {
//     searchParameters.query.bool.must.push({"match": {"ProductID": productID}});
//   }

//   return (dispatch) => {
//     console.log('searchParameters', JSON.stringify(searchParameters))
//     let addMessage = firebase.functions().httpsCallable('getUniqueNos');
//     return addMessage({ text: searchParameters }).then(function (result) {
//       const inventory = []
//       let sanitizedMessage = result.data.text;
//       sanitizedMessage.hits.hits.map((data, index) => {
//         inventory.push({ key: data._id, ...data._source })
//       })
//       // console.log('inventory', inventory)
//       return { totalItemsCount: sanitizedMessage.hits.total.value, searchResult: inventory }
//     });
//   }
// };

// export function getUniqueListForSalesReturn(from, size, storeID, productID, uniqueNo) {
//   let searchParameters = {
//     "from": from,
//     "size": size,
//     "query": {
//       "bool": {
//         "must": [
//           {
//             "match": {
//               "StoreID": storeID
//             }
//           },
//           {
//             "match": {
//               "Movement": "outward"
//             }
//           },
//           {
//             "match": {
//               "TransactionTypeModule": "sales"
//             }
//           },
//           {
//             "match": {
//               "IsDeleted": false
//             }
//           }
//         ],
//         "filter": {
//           "bool": {
//             "should": [],
//             "minimum_should_match": 1
//           }
//         }
//       }
//     },
//     "sort": [
//       {
//         "ActionOn": {
//           "order": "desc"
//         }
//       }
//     ]
//   }

//   if (uniqueNo.trim() !== "") {
//     searchParameters.query.bool.filter.bool.should.push({ "match_phrase": { "UniqueNo1":  uniqueNo.trim().toLowerCase()}})
//     searchParameters.query.bool.filter.bool.should.push({ "match_phrase": { "UniqueNo2":  uniqueNo.trim().toLowerCase()}})
//     searchParameters.query.bool.filter.bool.should.push({ "match_phrase": { "UniqueNo3":  uniqueNo.trim().toLowerCase()}})
//     searchParameters.query.bool.filter.bool.should.push({ "match_phrase": { "UniqueNo4":  uniqueNo.trim().toLowerCase()}})
//   }
//   if(productID!=="")
//   {
//     searchParameters.query.bool.must.push({"match": {"ProductID": productID}});
//   }

//   return (dispatch) => {
//     // console.log('searchParameters', JSON.stringify(searchParameters))
//     let addMessage = firebase.functions().httpsCallable('getUniqueNos');
//     return addMessage({ text: searchParameters }).then(function (result) {
//       const inventory = []
//       let sanitizedMessage = result.data.text;
//       sanitizedMessage.hits.hits.map((data, index) => {
//         inventory.push({ key: data._id, ...data._source })
//       })
//       // console.log('inventory', inventory)
//       return { totalItemsCount: sanitizedMessage.hits.total.value, searchResult: inventory }
//     });
//   }
// };
export function getUniqueNoIDBasedOnTransaction(
  storeID,
  productID,
  uniqueNo1,
  uniqueNo2,
  uniqueNo3,
  uniqueNo4
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/transaction/inventory/getUniqueNoByTransaction`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            storeID,
            productID,
            uniqueNo1,
            uniqueNo2,
            uniqueNo3,
            uniqueNo4,
          },
        }
      );

      return response.data.uniqueNumber;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}
// export function getUniqueNoIDBasedOnTransaction(
//   storeID,
//   productID,
//   uniqueNo1,
//   uniqueNo2,
//   uniqueNo3,
//   uniqueNo4
// ) {
//   let searchParameters = {
//     from: 0,
//     size: 1,
//     query: {
//       bool: {
//         must: [
//           {
//             match: {
//               StoreID: storeID,
//             },
//           },
//           {
//             match: {
//               ProductID: productID,
//             },
//           },
//           {
//             match: {
//               "UniqueNo1.keyword": uniqueNo1,
//             },
//           },
//           {
//             match: {
//               "UniqueNo2.keyword": uniqueNo2,
//             },
//           },
//           {
//             match: {
//               "UniqueNo3.keyword": uniqueNo3,
//             },
//           },
//           {
//             match: {
//               "UniqueNo4.keyword": uniqueNo4,
//             },
//           },
//         ],
//       },
//     },
//   };

//   return (dispatch) => {
//     // console.log('searchParameters', JSON.stringify(searchParameters))
//     let addMessage = firebase.functions().httpsCallable("getUniqueNos");
//     return addMessage({ text: searchParameters }).then(function(result) {
//       let uniqueNo = null;
//       let sanitizedMessage = result.data.text;
//       sanitizedMessage.hits.hits.map((data) => {
//         uniqueNo = { key: data._id, ...data._source };
//         // console.log('uniqueNo',uniqueNo)
//       });
//       return uniqueNo;
//     });
//   };
// }

export function checkIfUniqueNoIsUnique(storeID, productID, uniqueNo) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/checkifuniquenoisunique?storeID=${storeID}&productID=${productID}&uniqueNo=${uniqueNo}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return  response.data.uniqueNo;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}




export function getInTransitInventoryForAStore(storeID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/transaction/inventory/getintransitinventoryforastore/${storeID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
       return {
        totalItemsCount: response.data.totalCount,
        searchResult: response.data.inventory,
      };
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



// export function getInventoryToSale() {
//   let salesToPurchaseTransactionType = "";
//   return (dispatch, getState) => {
//     return database
//       .collection("Registration")
//       .doc(getState().user.user.RegistrationID)
//       .get()
//       .then((doc) => {
//         salesToPurchaseTransactionType = doc.data().InventoryToSale;
//         return salesToPurchaseTransactionType;
//       });
//   };
// }
export function getInventoryToSale() {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/transaction/getinventorytosale`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      return  response.data.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function getBatches(storeLocationID, productID, allBatches = false) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/transaction/inventory/batches?storeLocationID=${storeLocationID}&productID=${productID}&allBatches=${allBatches}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return  response.data.Batches || []; ;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getBatchAuditTrail(batchID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/transaction/batchaudittrail/${batchID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return  response.data.data || []; ;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getPurchaseEntryForPurchaseReturn(
  storeID,
  vendorCode,
  productID
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/transaction/inventory/purchaseentryforpurchasereturn`,
        {
          params: {
            storeID,
            vendorCode,
            productID,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data.inventory;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}






export function deleteInventoryInStock(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.delete(
        `${constants.API_URL}/inventory/instock/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
         return "success";
      }else{
        return "error";
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

